var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":_vm.showCover}},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading_wrap"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }